module.exports = __webpack_public_path__ + "static/media/nivel 2_400.4a7886c2.jpg";